<template>
  <div class="kbx-text-editor-toolbar">
    <span class="ql-formats">
      <editor-button type="bold"></editor-button>
      <editor-button type="italic"></editor-button>
      <editor-button type="underline"></editor-button>
      <editor-button type="strike"></editor-button>
    </span>
    <span class="ql-formats">
      <editor-color type="color"></editor-color>
      <editor-color type="background"></editor-color>
    </span>
  </div>
</template>

<script>
import EditorButton from './Button';
import EditorColor from './Color';

export default {
  components: {
    EditorButton,
    EditorColor,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?033ac0c6
 **/